import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { TEXTS, PRIVACY_CONTENT, PARTNERS, COOKIES } from "./constants";
import "./style";

const PrivacyStatement = ({ lang }) => (
  <div id="privacy-statement-page">
    {lang === "nl" ? (
      <>
        <h1>{TEXTS.PRIVACY_HEADER}</h1>
        <p className="last-update">{TEXTS.LAST_UPDATE}</p>
        <p>{TEXTS.INTRODUCTION}</p>
        {PRIVACY_CONTENT.map((item, index) => (
          <React.Fragment key={index}>
            <h3>{item.title}</h3>
            <p>
              {item.text} {item.link || ""}
            </p>
            {item.subheader && (
              <span className="subheader">{item.subheader}</span>
            )}
            {item.subtext && <p>{item.subtext}</p>}
          </React.Fragment>
        ))}
        <h1 className="cookies-header">{TEXTS.COOKIES_HEADER}</h1>
        <h3>{TEXTS.PARTNERS}</h3>
        <span className="subheader">{TEXTS.PARTNERS_SUBHEADER}</span>
        <p>{TEXTS.PARTNERS_INTRO}</p>
        <ul className="partners-list">
          {PARTNERS.map((partner, index) => (
            <li key={index}>
              <span className="subheader">{partner.name}</span>
              <p>{partner.description}</p>
              <ul className="description-list">
                {partner.list.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <h3>{COOKIES.USE}</h3>
        <p>{COOKIES.USE_DESCRIPTION}</p>
        <span className="subheader">{COOKIES.COOKIE_TYPES}</span>
        <p>{COOKIES.COOKIE_TYPES_INTRO}</p>
        <ul className="partners-list">
          {COOKIES.COOKIE_TYPES_LIST.map((type, index) => (
            <li key={index}>{type}</li>
          ))}
        </ul>
        {COOKIES.COOKIE_TYPES_MORE.map((item, index) => (
          <React.Fragment key={index}>
            <span className="cookie-type">{item.name}</span>
            <p>{item.description}</p>
            {item.list && (
              <ul className="partners-list">
                {item.list.map((info, infoIndex) => (
                  <li key={infoIndex}>{info}</li>
                ))}
              </ul>
            )}
          </React.Fragment>
        ))}
        <span className="subheader">{COOKIES.REMOVAL}</span>
        <p>{COOKIES.REMOVAL_DESCRIPTION}</p>
        <span className="subheader">{COOKIES.SWITCHING}</span>
        <p>{COOKIES.SWITCHING_DESCRIPTION}</p>
        <ul className="partners-list">
          {COOKIES.BROWSERS.map((browser, index) => (
            <li key={index}>
              <span className="cookie-type">{browser.name}</span>
              <ul className="description-list">
                {browser.list.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <p>{COOKIES.MORE_INFO}</p>
        <ul className="partners-list">
          {COOKIES.MORE_INFO_LIST.map((info, index) => (
            <li key={index}>{info}</li>
          ))}
        </ul>
        <h3>{COOKIES.ACTIVE_COOKIES}</h3>
        <p>{COOKIES.ACTIVE_COOKIES_DESCRIPTION}</p>
        <table className="cookies-table">
          <thead>
            <tr>
              {COOKIES.TABLE_COLUMNS.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COOKIES.TABLE_CONTENT.map((content, index) => (
              <tr key={index}>
                <td>{content.type}</td>
                <td>{content.validity}</td>
                <td>{content.origin}</td>
                <td>
                  <p>{content.purpose}</p>
                  {content.purpose_list && (
                    <ul className="partners-list">
                      {content.purpose_list.map((p, pIndex) => (
                        <li key={pIndex}>{p}</li>
                      ))}
                    </ul>
                  )}
                  {content.purpose_end || ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    ) : (
      <>
        <h1>{TEXTS.EN_HEADER}</h1>
        <p className="en-intro">{TEXTS.EN_INTRO}</p>
        <p>{TEXTS.EN_CONTENT}</p>
      </>
    )}
  </div>
);

export default connect(state => ({
  lang: _.get(state, "app.user.profile.Language", "nl")
}))(PrivacyStatement);
